import { ComponentPropsWithoutRef } from 'react';

import { cn } from '@components/primitives/utilities';

import css from './styles.module.css';

export interface EQLFilterOverflowProps
  extends Omit<ComponentPropsWithoutRef<'button'>, 'children'> {
  count: number;
  expanded?: boolean;
}

export function EQLFilterOverflow({
  count,
  expanded,
  className,
  ...props
}: EQLFilterOverflowProps) {
  if (count <= 0) return null;

  return (
    <button type="button" className={cn(css.overflow, className)} {...props}>
      {expanded ? '-' : '+'}
      {count} {expanded ? 'less' : 'more'}
    </button>
  );
}
